import {Component, Input, OnInit} from '@angular/core';

import {BusinessEvent} from '../../../../../commons/models/domain/BusinessEvent';
import {Vehicle} from '../../../../../commons/models/domain/Vehicle';
import {Driver} from '../../../../../commons/models/domain/Driver';

import {NewDataStoreService} from '@shared/services/new-data-store.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'tk-event-list-alarm-item-info',
  styleUrls: ['./event-list-item-info.component.less'],
  templateUrl: './event-list-item-info.component.html'
})
export class EventListItemInfoComponent implements OnInit {

  /**
   * Event to show
   */
  @Input() public event?: BusinessEvent;

  /**
   * Vehicle if event points to any
   */
  public vehicle?: Vehicle;

  /**
   * Driver if event points to any
   */
  public driver?: Driver;

  /**
   * Default vehicle name if event does not point to any vehicle
   */
  public defaultVehicleName: string;

  /**
   * Default driver name if event does not point to any driver
   */
  public defaultDriverName: string;

  constructor(
    private newDataStoreService: NewDataStoreService,
    private translate: TranslateService
  ) {
    this.defaultVehicleName = this.translate.instant('events-list.unknown-vehicle');
    this.defaultDriverName = this.translate.instant('events-list.unknown-driver');
  }

  public ngOnInit(): void {
    // Get names of vehicle and driver if any
    if (this.event?.DI) {
      const driver = this.newDataStoreService.getDriverById(this.event?.DI);
      if (driver) {
        this.driver = driver;
      }
    }

    if (this.event?.VI) {
      const vehicle = this.newDataStoreService.getVehicleById(this.event?.VI);
      if (vehicle) {
        this.vehicle = vehicle;
      }
    }
  }
}
